/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createTextPlaceholderStyles = makeStyles(() => ({
  icon: {
    '&>svg': {
      width: '10px',
      height: '10px',
      marginLeft: '-1px',
    },
  },
}));
